/* eslint-disable @typescript-eslint/no-explicit-any */
export function useLocalStorage<T extends string>(keys: T[]) {
	type Keys = (typeof keys)[number];

	const storage = ref<{ [key in Keys]: string | null }>();

	watch(
		storage,
		() => {
			if (!storage.value) return;

			Object.entries(storage.value).forEach(([key, value]) => {
				if (value === null) {
					return _deleteItem(key);
				}

				_setItem(key, value);
			});
		},
		{ immediate: true }
	);

	onMounted(() => {
		storage.value = keys.reduce((acc, curr) => {
			return {
				...acc,
				[curr]: _getItem(curr),
			};
		}, {} as { [key in Keys]: string | null });
	});

	function _getItem(name: string) {
		try {
			if (import.meta.client) {
				return localStorage.getItem(name);
			}

			return null;
		} catch (error) {}
	}

	function _setItem(name: string, value: any) {
		try {
			if (name === undefined || value === undefined || !import.meta.client) {
				return;
			}

			const val = typeof value === 'object' ? JSON.stringify(value) : value;

			localStorage.setItem(name, val);
		} catch (error) {}
	}

	function _deleteItem(name: string) {
		try {
			if (import.meta.client) return;

			localStorage.removeItem(name);
		} catch (error) {}
	}

	return {
		storage,
	};
}
